import { render, staticRenderFns } from "./InspectionTab.vue?vue&type=template&id=168f7fd0&scoped=true"
import script from "./InspectionTab.vue?vue&type=script&lang=js"
export * from "./InspectionTab.vue?vue&type=script&lang=js"
import style0 from "./InspectionTab.vue?vue&type=style&index=0&id=168f7fd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168f7fd0",
  null
  
)

export default component.exports